import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { EVENT_TYPE } from '../../../../constants/index';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

export default makeStyles(theme => ({
  subNavigationWrap: {
    [theme.breakpoints.down('md')]: {
      position: 'sticky',
      left: 0,
      top: 0,
      backgroundColor: theme.mixins.White(),
      zIndex: 1000,
      transition: 'top 300ms cubic-bezier(0, 0, 0.2, 1) 0ms',
      '&.header-added': {
        top: theme.spacing(10),
      },
    },

    '& .hide': {
      visibility: 'hidden',
    },
    '& .remove': {
      display: 'none',
    },
    '&.sticky.ghostdiv-reached': {
      position: 'static',
      transform: 'none',
      transition: 'none',
    },
  },
  subNavigationListWrap: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  subNavigationList: {
    listStyle: 'none',
    display: 'flex',
    padding: '0',
    margin: '0',
    position: 'relative',
    overflow: 'scroll',
    [theme.breakpoints.up('lg')]: {
      overflow: 'inherit',
    },
  },
  subNavigationListItem: {
    paddingTop: pxToRem(26.84),
    paddingBottom: pxToRem(26.84),
    ...theme.mixins.paddingRight(theme.spacing(4)),
    display: 'flex',
    alignItems: 'center',
    flex: '1 0 auto',
    '& .MuiTypography-root': {
      textDecoration: 'none',
      textTransform: 'uppercase',
      display: 'block',
      color: theme.palette.text.defaultText,
      '&:hover': {
        color: theme.palette.text.primary,
      },
      '&.active': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.common.SeaGreen,
        padding: '10px 23px',
        borderRadius: borderRadius.b50px,
      },
    },
  },
  moreNavItemWrap: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      textAlign: theme.mixins.textRight(),
    },
  },
  moreItemButton: {
    height: '100%',
    borderBottom: `4px solid ${theme.mixins.White()}`,
    color: theme.mixins.Black(),
    '&.active': {
      color: theme.mixins.Black(),
      borderBottom: ({ contentType }) => contentType === EVENT_TYPE ? `4px solid ${theme.mixins.DarkTurquoise()}` : `4px solid ${theme.mixins.AbuDhabiOrange()}`,
    },
    '&:hover': {
      borderBottom: ({ contentType }) => contentType === EVENT_TYPE ? `4px solid ${theme.mixins.DarkTurquoise()}` : `4px solid ${theme.mixins.AbuDhabiOrange()}`,
      '& .MuiButton-label': {
        textDecoration: 'none',
      },
    },
    '& .MuiButton-label::after': {
      content: 'none',
    },
  },
  hideItem: {
    display: 'none',
  },
  moreMenu: {
    '& .MuiMenu-paper': {
      borderRadius: borderRadius.b0,
      border: `1px solid ${theme.mixins.Grey(400)}`,
      '& .active': {
        color: theme.mixins.Black(),
      },
    },
    '& .MuiList-root': {
      padding: '0',
      maxHeight: pxToRem(210),
      minWidth: theme.spacing(27),
    },
    '& .MuiListItem-root': {
      color: theme.palette.text.tertiary,
      margin: `0 ${pxToRem(16)}`,
      padding: 0,
      '&:hover': {
        background: 'none',
        '& .MuiTypography-root': {
          color: theme.mixins.Black(),
        },
      },
      '& .MuiTypography-root': {
        borderBottom: `1px solid ${theme.mixins.Grey(400)}`,
        width: '100%',
        padding: `${pxToRem(14)} 0`,
        textDecoration: 'none',
      },
      '&:last-child .MuiTypography-root': {
        borderBottom: 'none',
      },
    },
  },
}));
